export default __webpack_public_path__ + "static/media/mairie.c0febf03.png";